export const l = {
    //通用
    dty: '电梯云',
    subtitle: "一站式电梯安全管理平台",
    smart_screen: '智慧屏',
    face: '人脸识别',
    id: "ID",
    save: '保存',
    save_success: '保存成功',
    confirm: '确认',
    cancel: '取消',
    create: '新建',
    fresh: '刷新',
    add: '添加',
    add_success: '添加成功',
    add_fail: '添加失败',
    edit: '编辑',
    edit_success: '编辑成功',
    edit_fail: '编辑失败',
    delete: '删除',
    delete_success: '删除成功',
    delete_fail: '删除失败',
    no_data: '未填写',
    no_specific_location: '未选择具体位置',
    total_data: '共',
    date: '日期',
    unit1: "条",
    unit2: "元",
    data: "数据",
    warn: "警告",
    continue: "继续",
    success: "成功",
    fail: "失败",
    open: '开启',
    close: '关闭',
    check: '查看',
    prompt: '提示',
    yes: '是',
    no: '否',
    close_f_notice: '关闭故障消息提示',
    file: "文件",
    //登录页 login.vue
    login_account: '登录您的账号',
    mobile_username: '手机号或用户名',
    mobile: '手机号',
    pwd: '密码',
    pwd_old: '旧密码',
    pwd_new: '新密码',
    confirm_new_pwd: '确认新密码',
    login: '登录',
    forget_pwd: '忘记密码',
    captcha: '验证码',
    get_captcha: '获取验证码',
    submit: "提交",
    back_official_web: "返回官网",
    back_login: "返回登录",
    goback: "返回",
    //路由配置 router.js
    monitor: "监控",
    err_403: "403-权限不足",
    err_404: "404-页面不存在",
    err_net: "无法访问此网站",
    err_500: "服务器500错误",
    home: '首页',
    sim_statistics: "sim卡统计",
    normalCount: "正常",
    oweCount: "欠费",
    stopCount: "停机",
    ExpireCount: "过期",
    all_lift: "全部电梯",
    cum_fault: "累计故障",
    online_lift: "在线电梯",
    maintenance_lift: "维保电梯",
    fault_num: "故障数量",
    today_fault: "今日的故障",
    today_running: "今日运行",
    today_add_lift: "今日新增电梯",
    online: "在线",
    offline: "离线",
    online_rate: "电梯在线率",
    wait_maintained: "待维保",
    maintained: "已维保",
    device_maintenance: "电梯维保",
    fault_rate: "电梯故障率",
    normal: "正常",
    repair: "检修",
    finish: "完成",
    terminal_statistics: "终端统计",
    terminal_app: "电梯云移动端",
    terminal_smart: "智慧屏终端",
    terminal_face: "人脸识别终端",
    terminal_new_wcr: "WCR终端4G版",
    terminal_old_wcr: "WCR终端2G版",
    terminal_wcr: "WCR终端",
    maintenance_statistics: "维保统计",
    fault_deal_statistics: "故障处理统计",
    //主页面 main.vue
    person_info: "个人信息",
    job_num: "工号",
    position: "职位",
    phone_no: "电话",
    e_mail: "邮箱",
    company: "公司",
    department: "部门",
    select: "选择",
    change_pwd: "修改密码",
    log_out: "注销登录",
    wipe_cache: "清空缓存",
    //导航 系统管理
    system_manage: '系统管理',
    //用户管理
    user_manage: '用户管理',
    company_structure: '组织',
    role_manage: "部门角色管理",
    add_role: "添加新角色",
    username: '用户名',
    username_account: '用户名(登录账户)',
    name: '姓名',
    real_name: '真实姓名',
    birthday: '生日',
    operation: '操作',
    //支付账户管理
    pay_account: '支付账户',
    pay_manage: '支付账户管理',
    recharge: '充值',
    recharge_amount: '充值金额',
    send_sms: '发送推送通知',
    recharge_success: "充值成功",
    //小区管理
    community: '小区',
    community_manage: "小区管理",
    unfold: "展开",
    community_name: "小区名称",
    region: "区域",
    region_of: "所属区域",
    detail_address: "详细地址",
    address: "地址",
    community_info: "小区信息",
    create_community: "创建小区",
    list_page: '列表页',
    detail_page: '详情页',
    report_interval: '上报间隔(秒)',
    duration: '持续时间(秒)',
    para_monitor: '参数监控',
    //系统设置
    system_setting: '系统设置',
    system_select: '系统设置选项',
    basic_set: '基本设置',
    personal_account: '个人账号',
    info_set: '信息设置',
    data_monitor_page: '数据监控页',
    data_monitor_set: '数据监控等信息配置',
    webRTC_set: 'webRTC配置',
    webRTC_related_set: 'webRTC相关配置',
    app_v_manage: 'App版本管理',
    dtyApp_v_manage: '电梯云App版本管理',
    face_v_manage: '人脸终端版本管理',
    faceApp_v_manage: '人脸识别终端App版本管理',
    smart_v_manage: '智慧屏终端版本管理',
    smartApp_v_manage: '智慧屏终端App版本管理',
    smartlite_v_manage: '智慧屏Lite终端版本管理',
    smartlitApp_v_manage: '智慧屏Lite终端App版本管理',
    fault_set: '故障设置',
    fault_msg_set: '故障提醒信息设置',
    aliyun_interface_set: '阿里云接口配置',
    newWcr_v_manage: '新Wcr版本管理',
    api_set1: '地方监管部门API接口接入许可字段配置',
    api_set2: '配置接入许可字段',
    sys_nettrans_server: "内网透传服务器配置",
    current_department: '当前部门',
    upload_avatar: '上传头像',
    upload_success: '上传成功',
    upload_fail: '上传失败',
    upload_apk: '点击上传apk文件',
    upload_img: '上传图片',
    upload: '上传',
    all_fault_alarm: '故障告警全选',
    all_sms_alarm: '发送公众号推送全选',
    package: '套餐',
    package_name: '套餐名',
    package_type: '套餐类型',
    month_sub: '包月',
    superposition: '叠加',
    flow_data: '流量',
    original_price: '原价',
    discount_price: '折后现价',
    package_id: '套餐编号',
    list_v: '版本列表',
    set_list: '配置列表',
    region_select: '推送平台标签',
    region_no_select: '',
    push_type: '推送方式',
    push_setting: '推送配置',
    push_name: '平台名称',
    push_port: '推送端口',
    pingtai: '平台',
    push_time: '推送时间',
    manufacturer: '电梯可见公司',
    select_manufacturer1: '请选择电梯可见公司',
    select_manufacturer2: '请选择电梯可见公司(可搜索)',
    push_para: '推送参数',
    para_des: '参数说明',
    add_filed: '新增字段',
    file_des: '字段文字说明',
    add_push: '新增推送配置',
    fault_name: '故障名称',
    fault_mean: '故障含义',
    fault_alarm: '故障告警',
    send_sms2: '发送公众号推送',
    // 导航 乘梯管理
    take_ladder_manage: '乘梯管理',
    // 业主管理
    owner_manage: '业主管理',
    add_owner: '添加业主',
    build_unit: '楼宇单元',
    lift_permission: '乘梯权限',
    lift_position: '乘梯位置',
    select_floor: '选择楼层',
    deadline: '过期时间',
    face_lift: '人脸乘梯权限',
    face_collected: '已采集人脸',
    face_no_collect: '未采集人脸',
    property_manage: '物业管理',
    ordinary_owner: '普通业主',
    lift_no_permission: '暂无乘梯权限',
    entry_time: '录入时间',
    authorize: '授权',
    authorize_success: '授权成功',
    authorize_fail: '授权失败',
    give_lift: '授权乘梯权限',
    owner_lift: '业主乘梯权限',
    add_address: '添加地址',
    add_new_address: '添加新地址',
    community_list: '小区列表',
    //已删钥匙
    deleted_key: '已删钥匙',
    deleted_keys: '已删钥匙列表',
    bound_lift: '绑定电梯',
    key_floor: '所在楼层',
    key_owner: '钥匙隶属业主姓名',
    // 导航 电梯管理
    device_manage: '设备管理',
    //设备列表
    device_list: '电梯列表',
    remove_device_list: "删除电梯列表",
    my_focus: '我的关注',
    device_monitor: '电梯监控',
    map_location: '地图位置',
    back_devices: '返回电梯列表',
    batch_import: '批量导入',
    filter: '筛选',
    filter_lift: '筛选电梯',
    elevator_name: '电梯名称',
    device_model: '设备型号',
    device_type: '电梯类型',
    device_number: '厂家代码',
    device_num: '设备号',
    terminal_id: '终端ID',
    batch_operation: '批量操作',
    add_device: '添加电梯',
    batch_edit: '批量修改',
    location: '地理位置',
    set_excel: 'Excel表格配置选项',
    down_excel: '表格模板下载',
    select_bound_lift: '选择绑定真实电梯',
    virtual_lift_id: '虚拟电梯WCR终端ID',
    wcr2G_terminal: '2G WCR',
    total_floor: '总楼层',
    floor: '楼层',
    positive_floor: '正楼层',
    negative_floor: '负楼层',
    floor_editor: '楼层编辑器',
    through_door: '贯通门',
    manual_door: '手动门',
    remote_sync: '远程同步',
    select_push_city: '推送平台',
    lift_type: '电梯类型',
    lift_id: '电梯编号',
    lift_mode: '电梯型号',
    rated_speed: '额定速度（m/s）',
    rated_load: '额定载重（kg）',
    main_lift: '选定主电梯',
    lift: '电梯',
    virtual_lift: '虚拟电梯',
    get_coordinates: '获取经纬度',
    company_logo: "上传公司logo",
    latitude: '纬度',
    longitude: '经度',
    select_location: '点击选择位置',
    face_terminal_id: '人脸识别终端ID',
    manufacturer_branch: '电梯可见公司下属分公司',
    mt_company: '维保公司',
    mt_person: '维保人',
    add_maintenance: '新建维保负责人',
    principal: '负责人',
    add_principal: '新建负责人',
    terminal: '终端',
    ad_company: '广告公司',
    alarm_mobile: '故障告警人',
    alarm_description: '公众号推送说明',
    add_alarm_mobile: '新建告警人',
    sms_count: '已发公众号推送数', // 阿里云
    sms_limit: '短信发送上限',   // 阿里云
    sms_enable: '短信发送功能',  // 阿里云
    sms_enable_0: '禁用',
    sms_enable_1: '仅国内',
    sms_enable_2: '国内与海外',
    add_capacity: '附加能力',
    select_all: '全选',
    unbound: '未绑定',
    batch_edit_info: '批量修改电梯信息',
    select_position: '位置标定',
    current_longitude: '当前位置经度',
    current_latitude: '当前位置纬度',
    selected_lifts: '已选择电梯列表',
    clear: '清空',
    lift_info: '电梯信息',
    device_state: '电梯状态',
    terminal_type: '终端类型',
    lift_name: '电梯名称',
    device_unique_id: '电梯唯一工号',
    lift_factory: '电梯厂',
    dty_model: '电梯云测试模板',
    code_model: '(厂家定义)',
    lift_type1: '曳引与强制驱动电梯',
    lift_type2: '杂物电梯',
    lift_type3: '液压驱动电梯',
    lift_type4: '自动扶梯与自动人行道',
    video_monitor: '视频监控',
    scan_lift: '扫码乘梯',
    video_call: '远程对讲',
    click_help: '一键求救',
    video_ad: '视频广告',
    //********************************************************************************
    terminal_operation_list: '终端操作列表',
    fault_statistics: '电梯故障统计',
    sendSync: '同步楼层信息',
    get_real_time_param: '获取实时参数',
    real_time_param: '实时参数',
    restart_APP: "重启终端APP",
    read_param: '读取终端参数',
    read_setting_file: "读取配置文件",
    smart_screen_param: '智慧屏幕参数',
    sim_query: 'sim卡查询',
    check_face_version: '人脸终端版本',
    check_screen_version: '安卓终端版本',
    down_ladder_code: '下载乘梯码',
    pusher_log: '推送日志',
    log: '日志',
    Real_time_status: '实时状态',
    history_monitor: '调取历史监控',
    remote_file: '远程文件管理',
    driver: '司机',
    special: '专用',
    fire: '消防',
    fire_start: '消防初态',
    Lock_ladder: '锁梯',
    password: '密码',
    confirm_password: '确认密码',
    fault: '故障',
    scram_loop: '急停回路',
    door_lock_loop: '门锁回路',
    overload: '超载',
    CAN_fault: 'CAN 故障',
    blackout_emergency: '停电应急',
    earthquake: '地震',
    basic_function: '基本功能',
    data_monitor: '数据监控',
    not_configed: '未配置',
    extend_functionality: '扩展功能',
    remote_operate: '远程操控',
    remote_lock_ladder: '远程锁梯',
    remote_unParking: '远程解锁',
    remote_unlock_ladder: '远程解锁',
    remote_stop: '远程停梯',
    remove_stop: '解除停梯',
    remote_down: '远程迫降',
    remote_update_pwd: '远程修改密码周期',
    password_cycle: '密码周期',
    remote_reset: '远程复位',
    device_param: '电梯参数',
    main_board_param: '主板参数',
    extension_data: '扩展数据',
    outbound_situation: '外呼情况',
    in_select_case: '内选情况',
    in_select: '内选',
    out_select: '外呼',
    up_select: '上呼',
    down_select: '下呼',
    alert_warn: '电梯未绑定终端，或者终端处于离线状态',
    simulation: '仿真',
    video: '视频',
    stream_m3u8: 'm3u8视频流',
    item_name: '项目名称',
    device_address: '电梯位置',
    no_terminal_id: '未绑定终端',
    current_fault_record: '当前电梯故障记录',
    return_table: '返回表格',
    change_chart: '切换至统计图',
    note: '备注',
    loading1: '远程加载电梯运行参数中...',
    loading2: '连接终端中...',
    terminal_param: '终端参数',
    param_list: '参数列表',
    return_param_content: '参数返回内容',
    history_file: '历史监控视频列表',
    select_time: '选择开始时间与结束时间',
    one_download: '一键下载',
    new_psw_cycle: '新密码周期',
    card_from: 'sim源自',
    bind_date: '绑定日期',
    activation_date: '激活日期',
    open_card: '开卡日期',
    flow_expire: '流量到期时间',
    pay_date: '上次付款时间',
    next_pay_date: '下次付款时间',
    flow_total: '当月总流量',
    flow_used: '已使用流量',
    write: '写入',
    read: '读取',
    program_version: '程序版本号',
    param_version: '参数版本号',
    configuration_file: '配置文件',
    main_board_param_config: '主板参数配置项',
    statistics: '统计信息',
    total_number: '总运行次数（次）',
    total_time: '总运行时间（h）',
    total_power: '总运行能耗（KW·h）',
    total_opend: '总运行开门次数（次）',
    floors_show: '楼层显示',
    protocol_version: '协议版本号',
    file_name: '文件名称',
    download_status: '下载状态',
    file_size: '文件大小',
    monitor_time: '监控时间',
    remove: '移除',
    is_delete: '确定删除此条记录吗？',
    file_is_download: '该文件正在下载中，无法执行此操作',
    fault_id: '故障ID',
    fault_param: "故障时参数",
    sequence: '序号',
    param_name: '参数名称',
    param_value: '参数值',

    cancel_command: '取消指令',
    reset: '复位',
    restor_reset: '恢复出厂并复位',
    save_param: '保存参数',
    save_reset: '保存参数并复位',
    enter_level1: '进入安全等级1',
    enter_level2: '进入安全等级2',
    sended_command: '指令已发送',

    unknown_fault: '未知故障',
    door_lock_loop1: "门锁回路1",
    scram_loop1: "急停回路1",
    door_area: "门区",
    door_area1: "门区1",
    door_area2: "门区2",
    converter_fault: "变频器故障",
    KMC: "KMC",
    KDY: "KDY",
    opend_brake: "开闸",
    inverter_run: "变频器运行",
    inverter_enable: "变频器使能",
    KMC_output: "KMC输出",
    KDY_output: "KDY输出",
    door_area_up: "上门区",
    door_area_down: "下门区",
    station_broadcast: "报站信号",
    run_down: "下行",
    run_up: "上行",
    running: "运行",
    running1: "运行1",
    front_door: '前门',
    back_door: '后门',
    front_door_opened: "前门开门到位",
    front_door_opening: "前门开门",
    front_door_closed: "前门关门到位",
    front_door_closing: "前门关门",
    front_light_curtains: "前门光幕",
    front_touch_board: "前门触板",
    back_door_opened: "后门开门到位",
    back_door_opening: "后门开门",
    back_door_closed: "后门关门到位",
    back_door_closing: "后门关门",
    back_light_curtains: "后门光幕",
    back_touch_board: "后门触板",
    load_less: "轻载",
    load_more: "重载",
    load_full: "满载",
    load_over: "超载",
    control_multiple: "群控",
    control_double: "并联",
    endpoint_secondary_up: "上次端站",
    endpoint_secondary_down: "下次端站",
    endpoint_up: "上端站",
    endpoint_down: "下端站",
    limit_up: "上限位",
    limit_down: "下限位",
    run_status: "电梯运行状态", //  1-自动， 2-检修， 3-司机， 4-专用， 5-消防， 6-锁梯， 7-VIP， 8-故障
    // run_model:", //0-正常  1-停电应急（新） 2 - 地震（新）3-消防（新） 4-消防初态（新） 5-专用  6-司机 7-VIP
    floor_current: "当前楼层", //（绝对，最底层为1）
    running_interval: "运行曲线区间", // 0-停止， 1-加速， 2-稳速， 3-制动， 4-爬行， 5-维持零速
    zero_speed: "零速",
    change_speed_mark: "换速",
    curve_change_speed: "曲线换速",
    change_direction_openid: "换向开门",
    running_speed: "运行速度", //（m/s）
    lift_status: '电梯状态',
    stop: '停止',
    safety_circuit: '安全回路',
    closed: '闭合',
    break: '断开',
    flat_signal: '平层信号',
    effective: '有效',
    no_effective: '无效',
    shaft_switch: '井道开关',
    cage_load: '轿厢载重（称重）',
    digital_cage: "数字式轿厢称重模块读数 --%（百分数不为零就显示）",
    front_signal: '前门信号',
    back_signal: '后门信号',
    door_opened: '开门到位',
    door_closed: '关门到位',
    safety_light_curtain: '安全光幕',
    security_contact: '安全触板',
    open_door_instruction: '开门指令',
    close_door_instruction: '关门指令',
    select_signal_ab: "内选信号：（仅显示有应答标志的数字，绝对楼层）",
    smart_screen_title: "电梯云智慧屏管理界面",
    end_time: '到期日期',
    plays: '播放次数',
    add_video: '添加视频',
    edit_subtitles: '编辑字幕',
    select_sound: '选择报站音效',
    direction_wind: '风向',
    wind: '风力',
    temperature: '温度',
    level: '级',
    volume: '音量调节',
    system_volume: '系统音量',
    media_volume: '视频音量',
    station_volume: '音频音量',
    current_brightness: "当前亮度",
    brightness_control: '亮度调节',
    open_volume: '开门声音',
    close_volume: '关门声音',
    floor_volume: "报站声音",
    scrolling_speed: '字幕滚动速度',
    next: '下一步',
    sync_msg_fail: "同步消息发送失败",
    no_update_file: '未修改配置文件',
    no_set_parameters: '存在未设置参数的视频',
    remote_sync_data: "远程数据同步中",
    Mon: '星期一',
    Tue: '星期二',
    Wed: '星期三',
    Thu: '星期四',
    Fri: '星期五',
    Sat: '星期六',
    Sun: '星期日',
    error: '错误',
    in: '于',
    occur: '发生',
    lift_fault: '电梯故障',
    fault_time: '故障时间',
    agree: '同意',
    focus: '关注',
    no_focus: '取消关注',
    click_focus: '点击关注',
    about_expire: '即将到期',
    out_of_traffic: '流量即将用尽',
    no_datas: '暂无数据',
    no_datas_curve: "暂无数据，或者相关曲线文件缺失",
    private_role: "私有角色",
    directions: '使用说明',
    dty_platform: '电梯云平台',
    operation_manual: "平台操作手册",
    role_res_instructions: '用户与权限管理说明',
    terminal_operation_manual: "智慧屏终端操作手册",
    face_operation_manual: "人脸识别终端操作手册",
    app_operation_manual: "电梯云APP操作手册",
    Login_failure: "登录失败",
    login_expired: '您的账号登录已过期，或在其他位置登录，请确保账号安全情况下，重新登录。',
    no_permission: "无访问权限，请联系企业管理员",
    chooseCompany: '选择公司继续操作',
    platform_res: '平台资源',
    app_res: "APP资源",
    dtzj_res: "电梯专家资源",
    //终端列表
    terminal_list: '终端列表',
    terminal_manage: '终端管理',
    yd_bound: '电梯工号绑定终端',
    terminal_identity: '终端身份',
    terminal_account: '终端账号',
    terminal_pwd: '终端密码',
    yd_unique_code: '电梯唯一工号',
    yd_id_add: '电梯唯一工号录入',
    input: '录入',
    no_connect: '未联网',
    wired_network: '有线',
    network: '联网',
    create_time: '创建时间',
    delete_time: "删除日期",
    click_copy_pwd: '点击复制密码',
    update_time: '更新时间',
    print: '打印',
    qr_code: '二维码',
    terminal_info: '终端信息',
    copy_info: '已复制到剪切板',
    //故障列表
    fault_list: '故障列表',
    fault_month: '选择故障发生月份(最近三年)',
    untreated: '未处理',
    processed: '已处理',
    fault_des: '故障说明',
    fault_code: '故障号',
    fault_no: '故障码',
    fault_explanation: '故障解释',
    resume: '恢复',
    history_delete: '历史删除记录',
    resume_condition: '恢复条件',
    fault_solution: '处理方案',
    fault_state: '故障时状态',
    device_info: '电梯信息',
    install_location: '安装位置',
    device_id: '电梯ID',
    terminal_number: '终端编号',
    alerter: '告警人',
    lift_device: '电梯设备号',
    fault_floor: '故障时所在楼层',
    occur_time: '发生时间',
    handle_time: '处理时间',
    state_display: '状态显示',
    state_para: '状态参数',
    auto: '自动',
    //sim卡列表
    sim_list: 'sim卡列表',
    sim_manage: 'SIM卡管理',
    sim_info: 'SIM卡信息',
    pay: '缴费',
    order: '订单',
    import: '导入',
    add_batch: '加入批处理',
    operator: '运营商',
    from_card: '出处',
    china_mobile: '移动',
    card_state: '卡状态',
    net_type: '网络类型',
    card_open_time: '开卡时间',
    card_end_time: '流量到期时间',
    effective_time: '生效时间',
    no_package_msg: '无套餐信息',
    ali_cloud: '阿里云',
    inactivated: '未激活',
    arrears: '欠费',
    out_service: '停机',
    account_cancel: '销户',
    will_expire: '即将过期',
    package_will_out: '流量即将用尽',
    package_will_out2: '流量即将用尽且到期',
    order_created: '订单已创建',
    write_off_time: '注销时间',
    package_end_time: '套餐到期时间',
    detail: '详情',
    number: '数量',
    // 导航 开发调试
    development: "开发调试",
    res_manage: '资源管理',
    server_exception: '服务端异常',
    terminal_exception: "终端异常",
    crash_log: '崩溃日志',
    //使用说明
    explain: '使用说明',
    "-1": '未知错误',
    401: "未登录",
    402: "您的账号登录异常，请重新登录",
    403: "账号登录过期，请重新登录",
    413: "密码过于简单，请重新设置密码",
    414: "账户信息不匹配，无权执行此操作",
    // 服务端响应,错误码
    4011: '用户不存在',
    4012: '用户不存在或者用户名、密码错误',
    4013: '用户密码至少包含一位数字、大小写字母、特殊字符（!、@、#、$、%、^、&、*）',
    4021: "删除失败,当前用户已被删除",
    4022: "删除失败",
    4023: "修改失败",
    4024: "输入的密码与旧密码不符，请重新输入",
    4025: "修改密码失败，当前用户不存在",
    4026: "手机号码已存在",
    4027: "用户名已存在",
    4031: '未找到绑定的电梯',
    4032: "请选择可操作的小区",
    4033: "当前业主已被删除或者不存在",
    4035: "授权失败",
    4037: "续期失败",
    4039: '操作失败,请检查当前钥匙是否已被删除',
    4041: "当前电梯已经收藏过了",
    4042: "当前电梯尚未收藏",
    4043: "绑定的终端ID号已被其他电梯绑定过了",
    4045: "删除失败，当前电梯已被删除",
    4044: '添加失败',
    4046: "参数错误,指令发送失败",
    4047: "当前用户密码错误,指令发送失败",
    4048: "文件错误",
    4049: "楼层只能是数字",
    4050: "文件内存在已经绑定过的终端",
    4061: "终端不存在",
    4062: "当前电梯唯一工号已存在",
    4071: '请求发生错误，请确保在合法的途径发起请求',
    4072: '您的公司无电梯云账户支付权限，请向系统管理员核实后操作',
    4073: '您的公司账户余额不足',
    4074: '您不是当前操作公司的支付账户操作专员，请更换充值指定账户或向系统管理员核实后进行充值操作',
    4001: '参数错误',
    4081: '今日已达最大发送次数，请明天重试',
    4082: '频率过快，请60s后继续发送',
    4084: '获取验证码失败',
    4085: '用户不存在或验证码已经失效',
    4086: '验证码错误',
    4087: '验证码过期',
    4088: '未选择当前操作公司',
    4090: '当前部门或公司存在下属，无法进行删除',
    4091: '人脸识别终端ID已被其他电梯绑定',
    4092: '未查询到当前设备',
    4093: '当前用户在iecs平台上不存在，无法添加电梯，请在iecs创建账户后执行此操作！',
    4094: '添加失败！当前BS号已被注册',
    4095: 'IMSI和BS号不匹配',
    4096: 'IMSI号已存在',
    4097: '请求过于频繁，请稍侯重试',
    4098: "手机号格式不正确",
    4099: "邮箱格式不正确",
    4100: "频率过快，请60秒后继续发送",
    4101: "邮箱已存在",
    4102: "参数错误，请输入正确的验证码",
    4103: "参数错误，缺失code",
    4104: "未查询到对应code的记录！",
    4105: "账号与密钥与原账号、原密钥相同",
    4106: "更新数据失败",
    4201: "电梯名称为必填项",
    4202: "维保工人字段内容格式不正确",
    4203: "告警人人字段内容格式不正确",
    4204: "文件中存在已经绑定过的SIM卡ICCID",
    4205: "iccid已与其他的终端ID绑定",
    4206: "电梯楼层为必填项并且取值范围为1~64",
    4207: "小区取值范围为正整数，不建议修改此项",
    4208: "维保公司值范围为正整数，不建议修改此项",
    4209: "贯通门值范围为0或1，不建议修改此项",
    4210: "额定速度取值范围为正整数或正小数（小数点后两位）",
    4211: "额定载重取值范围为正整数或正小数（小数点后两位）",
    4212: "厂家代码最大字符串长度为100",
    4213: "电梯型号最大字符串长度为100",
    4214: "ICCID最大字符串长度为20",
    4215: "终端ID最大字符串长度为16",
    4216: "设备代码最大字符串长度为100",
    4217: "电梯唯一工号最大字符串长度为34",
    4218: "品牌最大字符串长度为50",
    4219: "重复的iccid录入",
    4220: "重复的电梯唯一工号录入",
    4221: "重复的终端ID录入",
    4222: "文件中存在非法终端ID，请检查！",
    4223: "文件中存在非法电梯唯一工号，请检查！",
    4224: "存在不合法的手机号，请检查！",
    4225: "文件中存在重复的唯一工号，请检查！",
    4226: "管理员导入请设置可见电梯厂字段",
    4227: '同一公司中手机号不能重复',
    4228: '同一公司中邮箱不能重复',
    4229: '公司不存在，请刷新重试',
    4230: '当前位置存在绑定的电梯，不可删除',
    4231: '无法将当前自己操作的公司删除',
    5001: "终端回复超时",
    5002: '设备已离线',
    5003: '运行数据监控服务已过期',
    5004: '设备不存在',
    5005: '当前设备已被恢复，请勿连续操作',
    5006: '当前终端不存在',
    5007: '当前终端已被绑定，无法恢复',
    5008: '请填写用户名',
    5009: '请选择公司后操作',
    5010: '手机号已存在',
    6001: '原手机号错误',
    6002: '新手机号已与其他微信绑定',
    6003: '该手机号已与其他微信绑定',
    6004: '说明书接口调用失败',
    6005: '参数错误,请将不同语言提醒消息设置完整',
    push_param_error1: "请填写电梯出厂编号字段",
    push_param_error2: "请填写制造单位统一社会信用代码字段",
    push_param_error3: "请填写电梯注册码字段",
    type: '类型',
    role: '角色',
    bind_community: '绑定小区',
    contact: '联系人',

    web_permission: '平台权限',
    app_permission: '电梯云App权限',
    DTZJ_permission: '电梯专家APP权限',
    name1: '名称',
    find_community: '搜索小区名称',
    click_edit: '点击编辑',
    add_son: '添加下级',
    property: '属性',
    bind_test: '演示电梯绑定',
    bind_device: '绑定电梯',
    create_company: '创建公司',
    user_info: '用户信息',
    add_user: '新增用户',
    role_permission: '角色与权限',
    role_name: '角色名称',
    bind_permission: '绑定权限',

    create_department: '创建下级公司',

    subcompany: '子公司',

    edit_name: '修改名称',
    create_type: '创建方式',
    single: '单独',
    batch: '批量',
    batch_add_build: '批量创建楼',
    batch_add_unit: '批量创建单元',
    build_pre: '楼名前缀',
    build_suf: '楼名后缀',


    no_type: '序号类型',
    number1: '数字',
    letter: '字幕',
    customize: '自定义',
    start_no: '起始序号',
    end_no: '结束序号',
    build_no: '楼号',
    create_build_name: '生成楼名',
    unit_pre: '单元名前缀',
    unit_suf: '单元名后缀',
    create_unit_name: '生成单元名',
    pre: '前缀',
    customize_pre: '自定义前缀',
    start_floor: '起始楼层',
    end_floor: '结束楼层',
    users_floor: '每层用户数',
    delimiter: '分隔符',
    user_no_type: '户序号类别',
    create_user_name: '生成住户名称',
    batch_add: '批量创建',
    set: '设置',
    add_build: '添加楼',
    build: '楼',
    unit: '单元',
    tenement: '住户',
    add_unit: '添加单元',

    the_term: '期限',
    times: '次数',
    floor_name: '楼层名称',
    unstop: '此层不停',
    month_number: '当前月份数量',
    rename: '重命名',

    trap_persons: '困人统计',


    my_msg: '我的消息',
    no_msg: '暂无消息',
    refuse: '拒绝',
    notify_msg: '通知消息',
    sign_application: '签名审批申请',

    occur_location: '发生地点',

    exception: '异常',
    para: '参数',
    manager: '管理员',
    stack_track: '堆栈信息',
    redis_test: 'Redis测试',
    redis_count: 'Redis统计',
    resource: '资源',
    res_delete: '删除资源',
    res_edit: '修改资源',
    new_subsystem: '新建子级',
    new_sibling: '新建同级',
    copy_suc: '复制成功',
    detail_content: '详细内容',

    dty_explain1: '电梯云平台操作手册.pdf',
    dty_explain2: '电梯云平台用户与权限管理使用说明.pdf',
    smart_explain: '智慧屏操作手册.pdf',
    face_explain1: '8寸人脸识别乘梯一体机说明书.pdf',
    face_explain2: '10寸人脸识别乘梯一体机说明书.pdf',
    dty_app_explain: '电梯云APP使用手册.pdf',
    entrance_guard: '门禁',
    page_title: '页面标题',
    window: '窗口',
    renewal: '续期',


    account_balance: '账户余额',
    binding: '绑定',
    binding_suc: '绑定',
    cancel_binding_suc: '解除绑定成功',

    depart_num: '个部门',

    current_fault: '当前故障电梯数量',
    sim_over: 'sim卡费用即将到期和已到期数量',
    lift_trapped: '发生困人电梯数量',

    up: '上行',
    down: '下行',
    queryMaintenance: "查看维保记录",
    addMaintenance: "添加维保记录",
    m_depart: "维保单位",
    m_user: "维保人员",
    m_date: "维保日期",
    m_type: "维保类型",
    m_content: "维保内容",
    m_remarker: "备注",
    down_face: "下载人脸数据",
    push_data: "推送平台数据",
    shijian: '时间',
    device_curve_list: "电梯曲线分析",
    data_statistic: "数据统计",
    terminal_id_curve: "振动噪声监测终端",
    search: '搜索',
    device_history_curve: '电梯历史运行曲线分析',
    add_remark: "添加备注",
    look_remark: '查看备注',
    maintain_list: '维保列表',
    health: "健康度",
    start_time: '开始时间',
    final_time: "结束时间",
    last_m_weibao: '最后维保时间',
    lift_monitor_end_time: '电梯监控到期时间',
    show_lift_endtime: "是否开启对电梯配置过期时间权限",
    device_expire: '电梯监控权限已过期',
    change_community_role: '切换小区内身份',
    push_filed_setting: "推送字段配置",
    describe: "说明",
    end_time_device_list: "到期电梯列表",
    batch_renew: '批量续期',
    city: '城市',
    settings_desc: "配置说明",
    brand: '品牌',
    auto_unicom: '自动化联通',
    other: '其他',
    all_factory: '全部厂商',
    IMSI: 'IMSI',
    floor_station_door: '层*站*门',
    leave_factory_date: '出厂日期',
    throw_in_date: '投入日期',
    next_year_date: '下此年检日期',
    Delivery: '是否交付',
    CONTRACT: '合同号',
    INSTALLATION: '安装单位',
    INSTALLATIONMAN: '安装人',
    INSTALLATIONMANMOBILE: '安装人电话',
    CONSUMER: '使用单位',
    USEOCCASION: '使用场合',
    OWNER: '产权',
    PROPERTY: '物业单位',
    WYRY: '物业人员',
    WYDH: '物业电话',
    project_name: '项目名称',
    parts_life_settings: '部件使用时间配置',
    parts_name: '部件名称',
    life_limit: '寿命上限',
    life_limit_default: '寿命上限模板默认值',
    warn_monitor: '部件寿命预警',
    parts_warn_config: '部件预警配置',
    device_qrcode: '设备二维码',
    use_time: '使用时间',
    warn_time: '预警时间',
    warn_detail: '预警详情',
    running_time: '电梯在平台上线以来运行时长',
    to_zero: '归0',
    change_war_config: '切换预警配置',
    change_deviceInfo_config: '切换电梯信息配置',
    user_list: '用户',
    user_table: '用户列表',
    authority: '权限',
    visible_device: '电梯',
    assigned_to: '绑定',
    unassigned_to: '解绑',
    remove_device: '解绑公司',
    BS: 'BS号',
    remove_user: '删除人',
    remove_user_mobile: '删除人电话',
    band_unband_user: '绑定/解绑用户',
    band_company: '绑定公司',
    unband_user: '解除用户绑定',
    band_user: '绑定用户',
    // registerNumber:'设备注册码',
    equipment_code: '设备代码',
    register_number: '设备注册代码',
    selectuserofdevice: "选择用户查询名下电梯列表",
    none: '无',
    export: '导出',
    sync_all: '同步全部',
    synchronization_part: "同步部分",
    remote_controls: '是否开启远程控制',
    open_close_door: '开关门',
    call_lift: '远程呼梯',
    remote_open_door: '远程开门',
    remote_close_door: '远程关门',
    no_body: '无人',
    some_body: '有人',
    behavior: '行为',
    qr_id: '扫码器唯一标识',
    export_fault_record: '导出故障记录',

//     2024年4月1日·    新增aed功能列表
    aed_list: "AED列表",
    aed_fault_list: "AED故障列表",
    device_name: "设备名称",
    device_desc: '设备描述',
    event_list: "事件列表",
    event_code: "事件码",
    gb_event_no: "国标事件码",
    event_no: "事件码",
    event_name: "事件名称",
    event_explain: "事件说明",
    gb_fault_no: "国标故障码",
    company_info: "公司信息",
    event_save: "是否开启事件存储",
    set_pwd: "重设密码",
    pwd_again: "确认密码",
    pwd_again_not_empty: '确认密码不能为空',
    new_pwd_set: "新密码重设",
    menu_dtzj: "电梯专家",
    version_manage: "版本维护",
    data_manage: '数据维护',
    logs_manage: '日志统计',
    setting_item: "设置项",
    data_type: "数据类型",
    extract_code: "提取码",
    help_seekers: "求助人",
    seeking_help: "被求助人",
    upload_time: "上传时间",
    download: "下载",
    message_content: "消息内容",
    version_name: "版本名称",
    publisher: "发布者",
    publisher_time: "发布时间",
    publisher_new: "发布新版本",
    bl6_active: "bl6激活",
    holding_version: "电梯专家版本",
    mobile_model: "手机型号",
    mobile_sys: "电梯专家APP",

    // 2025年2月5日
    variety: '设备品种',
    variety_type1: "载货电梯",
    variety_type2: "曳引式货梯",
    variety_type3: "强制式货梯",
    variety_type4: "无机房货梯",
    variety_type5: "汽车电梯",
    variety_type6: "防爆货梯",
    variety_type7: "液压电梯",
    variety_type8: "液压客梯",
    variety_type9: "防爆液压客梯",
    variety_type10: "液压货梯",
    variety_type11: "防爆液压货梯",
    variety_type12: "杂物电梯",
    variety_type13: "自动扶梯",
    variety_type14: "自动人行道",
    manufacturing: '制造单位名称',
    import_agent_name: '进口代理商名称',
    production_date: '出厂日期',
    installation_name: '安装单位名称',
    installation_check_date: '安装监督检验日期',
    renovation_name: '改造单位名称',
    renovation_check_date: '改造监督检验日期',
    major_repairs_name: '重大修理单位名称',
    major_repairs_check_date: '重大修理监督检验日期',
    doors: '电梯层门数',
    up_rated_speed: '电梯上行额定速度',
    down_rated_speed: '电梯下行额定速度',
    mt_type1: '解救困人',
    mt_type2: '报警处置',
    mt_type3: '维护保养',
    mt_type4: '修理',
    mt_type5: '检测',
    mt_type6: '其他',
    opinion: '使用单位意见',
    whole_machine_code: "整机编码",
    mt_details: "维保详情",
    receive_time: "派工时间",
    maintain_num: '保单号',
    insurance_expire: "保险过期时间",
    insurance_number: '保险单号',
    insurance_unit: '投保单位',
    internal_code: '内部使用编码',
    mt_company_hotline: '维保热线',
    restore_time: "恢复时间",
    special_mode: '专用模式',
    switch_open: '开',
    switch_close: '关',
    pusher_config: "推送平台设置",
    add_account: '追加子账号',
    wuhan_pusher_config: '武汉推送账号生成',
    child_account: '子账号信息',
    batch_set_config: "批量接入/取消接入",
    access: "接入",
    cancel_access: "取消接入",
    push_scheme: "推送方案",
    doc_explain: "文档说明",
    doc_upload: "说明文档上传",
    pusher_name: "推送配置名称",
    active_code: '激活码',
    operate_user: '操作人',
    pusher_describe: '平台账号信息说明',
    pusher_account: '推送账号列表',
    account: '账号',
    secretKey: '密钥',
    pusher_code: '推送方案唯一码',
    relationship_structure: "当前设备绑定用户关系结构",
    lift_monitor_config: '电梯监控设备默认到期时间',
    warn_note: '注：',
    advanced_permission: '高级权限',
    all: '全部',
    voice: '语音',
    picture: '照片',
    feedback: '反馈',
    oscilloscope_curve: '示波器曲线',
    text: '文字',
    recorder_data: '记录仪参数',
    return_parameters: '回传参数',
    fault_analysis: '故障分析',
    maintenance_fault: '检修故障',
    no_maintenance_fault: '非检修故障',
    APK_type: 'APK类型',
    unknown_location: "未知地点",
    unset_elevator_address: "未设置电梯地址字段",
    address_parsing_error: "解析地址错误",
    btn_push_test: '设备通讯测试',
    delete_bind_terminal: '删除时绑定终端',
    btn_resume_device: '仅恢复基本信息数据',
    delete_device_record: '删除时设备记录',
    resume_bind_terminal: '恢复至原终端绑定',
    copy: '复制',
    sys_upgrade:'系统升级提示',
    readed:'我已阅读',
    sys_notice_config:'系统级消息提醒配置',


    // ============================================ remark  ============================================
    remark: '请输入用户名',
    remark1: '请输入手机号或用户名',
    remark2: '请输入密码',
    remark3: '请输入手机号',
    remark03: '请输入邮箱',
    remark4: '请输入验证码',
    remark5: '请输入新密码',
    remark6: '请再次输入新密码',
    remark7: '请输入旧密码',
    remark8: '旧密码不能为空',
    remark9: '新密码不能为空',
    remark10: '请输入公司或部门关键字',
    remark11: '请输入正确的手机号',
    remark12: '当前手机号已经被注册',
    remark13: '当前用户名已经被注册',
    remark14: '请输入正确的邮箱',
    remark15: '充值金额 (元)',
    remark16: '请输入充值金额',
    remark17: '厂商账户',
    remark18: '点击“确认”按钮继续完成充值',
    remark19: '请输入小区名称',
    remark20: '未填写详细地址',
    remark21: '详细地址 如:世纪路37号...',
    remark22: '二维码每日刷新次数',
    remark23: '二维码默认每日刷新次数，可在下发乘梯权限时修改',
    remark24: '请填写完整',
    remark25: '存在相同文件名是否继续上传并覆盖？',
    remark26: '上传文件失败,仅支持apk文件上传',
    remark27: '请选择城市',
    remark28: '注：APK上传成功后，大小和版本号自动同步到数据库,上传前请修改文件名为“diantiyun.apk”。',
    remark29: '无法加载',
    remark30: '注：此处上传APK文件大小、文件名与路径不用填写，但是皮肤版本号必须手动设置',
    remark31: '请填写推送参数',
    remark32: '请填写参数文字说明',
    remark33: '此项不能为空',
    remark34: '请填写字段key',
    remark35: '请填写字段文字说明',
    remark36: '当前手机号已被注册',
    remark37: '当前用户名已被注册',
    remark38: '请填写用户名',
    remark39: '请填写姓名',
    remark39_a: '请填写密码',
    remark39_b: '请再次输入密码',
    remark39_c: '请输入新密码',
    remark39_d: '密码不能存在空格',
    remark40: '请填写工号',
    remark14_c: '两次密码输入不一致',
    remark41: '请填写手机号',
    remark42: '请输入业主姓名或电话',
    remark43: '当前小区管理员身份',
    remark44: '请选择楼号单元号',
    remark45: '未选择楼层',
    remark46: '未选择到期时间',
    remark47: '未选择楼号单元号',
    remark48: '乘梯权限截止时间',
    remark49: '未填写最大获取次数',
    remark50: '单日最大获取次数',
    remark51: '扫码乘梯单日最大获取二维码次数',
    remark52: '添加二维码乘梯钥匙',
    remark53: '确定转换身份为物业管理?',
    remark54: '确定转换身份为普通业主?',
    remark55: '确定删除该业主当前位置信息?',
    remark56: '请选择位置',
    remark57: '业主已存在，新注册业主信息将绑定该手机号下，是否继续?',
    remark58: '请选择可操作的小区',
    remark59: '该位置下未找到相关主电梯',
    remark60: '获取电梯楼层信息失败',
    remark61: '没有乘梯权限的情况下，请填写通讯地址',
    remark62: '确定删除当前位置乘梯权限?',
    remark63: '确定删除该业主吗?删除后当前业主信息在当前小区内所有乘梯权限及通讯地址信息均被删除',
    remark64: '请选择当前可操作的小区',
    remark65: '未录入人脸数据',
    remark66: '已录入人脸数据',
    remark67: '请输入关键字',
    remark68: '只支持csv、xlsx、xls格式文件，请确认后上传',
    remark69: '点击配置Excel文件',
    remark70: '请输入关键字',
    remark71: '请选择所属小区（可搜索）',
    remark72: '请选择生产厂商（可搜索）',
    remark73: '请填写',
    remark74: '请选择安装位置',
    remark75: '详细地址，由省、市、区及具体地址组成',
    remark76: '注：当前选项用于对接地方监管部门平台，如需要请必填',
    remark77: '请选择电梯所在城市（可搜索）',
    remark78: '请选择电梯类型',
    remark79: '是否选为当前电梯作为主电梯',
    remark80: '请确定主电梯位置',
    remark81: '请确定主电梯',
    remark82: '请选择电梯可见公司下属分公司 (可搜索) ',
    remark83: '请选择维保公司(可搜索) ',
    remark84: '请选择维保负责人（可搜索，可多选）',
    remark85: '请选择电梯负责人（可搜索，可多选）',
    remark86: '请选择广告公司（可搜索）',
    remark87: '请选择故障告警人（可搜索，可多选）',
    remark88: '请输入大致位置',
    remark89: '请输入1~64之间的任意数字',
    remark90: '请输入完整信息',
    remark91: '请输入合法手机号',
    remark92: '请选择需要批量处理的电梯',
    remark93: '点击“确定”将离开当前页面并跳转至小区管理页面',
    remark94: '当前电梯已在批处理列表中，请勿连续操作',
    remark95: '未添加关注的电梯',
    remark96: '当前城市或者当前公司未设置接口字段信息，请联系管理员',
    remark97: '请先选择电梯所属的小区',
    remark98: '未选择文件',
    remark99: '为了保证数据结构统一性，请严格遵照模板填写!',
    remark100: '电梯云平台注册电梯信息填写模板',
    remark101: '请输入搜索内容',
    remark102: '请填写WCR终端ID',
    remark103: '请选择部门',
    remark104: '请输入电梯名称、故障名称等',
    remark105: '请选择具体月份',
    remark106: '您的充值订单已成功创建,系统正在处理中。',
    remark107: '该电梯未绑定终端或处于离线状态，无法执行操作',
    remark108: '连接终端失败!',
    remark109: '当前电梯处于监控状态无法执行此项操作！',
    remark110: '未选择下载数据',
    remark111: '确定下载所选？',
    remark112: '条数据',
    remark113: '虚拟电梯禁止执行此操作',
    remark114: '请输入您的登录密码',
    remark115: '指令需要您的登录密码',
    remark116: '请输入需要变动的参数',
    remark117: '请选择执行的指令',
    remark118: '密码不能为空',
    remark119: '请填写密码周期月份',
    remark120: '历史文件下载中无法执行此项操作',
    remark121: '搜索内容不能为空',
    remark122: '加载数据失败',
    remark123: '电梯运行参数获取超时!',
    remark124: '失败，请重试',
    remark125: '所选日期不能为空！',
    remark126: '获取超时',
    remark127: '无法连接到服务',
    remark128: '下载任务进行中...',
    remark129: '当前电梯未绑定人脸终端设备',
    remark130: '连接终端超时',
    remark131: '终端连接失败',
    remark132: '未知',
    remark133: '确定重启当前终端设备内部APP吗？',
    remark134: '重启成功',
    remark135: '指令发送失败，请重试',
    remark136: '主板返回数据超时',
    remark137: '数据读取中',
    remark138: '数据读取失败',
    remark139: "如果“贯通门”选项选中，则总楼层n+1~2n为后门内选",
    remark140: '如果“贯通门”选项选中，则超过32的上呼为后门上呼',
    remark141: '如果“贯通门”选项选中，则超过32的下呼为后门下呼',
    remark142: "上呼信号：（仅显示有应答标志的数字，绝对楼层）",
    remark143: "下呼信号：（仅显示有应答标志的数字，绝对楼层）",
    remark144: '电梯标准过期时间未设置',
    remark145: "请选择滚动字幕的到期时间！",
    remark146: "过期时间不能为空",
    remark147: "文件格式不正确！",
    remark148: '音频文件上传前，确保文件名是真实存在楼层，如下格式。1楼对应的文件名：1.mp3',
    remark149: "只能输入1~5之间的正整数",
    remark150: "字幕滚动速度只能为1~10的整数",
    remark151: '远程升级版本失败',
    remark152: '远程升级版本成功',
    remark153: '号故障',
    remark154: '请及时关注并处理',
    remark155: "当前电梯处于求救状态无法监控或拉取文件",
    remark156: "当前电梯处于监控状态无法拉取文件",
    remark157: "当前电梯处于文件下载状态无法监控",
    remark158: '当前设备版本',
    remark159: '最新版本为',
    remark160: '确定更新到最新吗',
    remark161: '升级终端版本消息发送失败',
    remark162: '终端远程升级中...',
    remark163: '主板参数返回失败,请重试',
    remark164: '读取参数失败，请重试',
    remark165: '点击可取消关注',
    remark166: '修改成功',
    remark167: '清除成功',
    remark168: '确定删除该公司？',
    remark169: '确定删除该部门？',
    remark170: '公司存在下属成员，不允许删除',
    remark171: '部门存在下属成员，不允许删除',
    remark172: '贯通门电梯总楼层不可大于32',
    remark173: '关注成功',
    remark174: '返回电梯云官网',
    remark175: '返回当前所选公司平台首页',
    remark176: '返回上一页',
    remark177: ' 404-页面不存在',
    remark178: '403-权限不足',
    remark179: '500-服务端错误',
    remark180: '无法连接到服务器',
    remark181: '尝试运行网络诊断器',
    remark182: '功能开发中',
    remark183: '密码已修改，请重新登录',
    remark184: '更改楼层信息，需要同步到乘梯设备终端，请选择同步方式',
    remark185: "同步到当前终端设备",
    remark186: "同步到所属证书下所有终端设备",
    remark187: '指令发送成功',
    remark188: '未获取当前程序版本号',
    remark189: '未获取当前参数版本号',
    remark190: '写入的参数不能为空',
    remark191: '指令发送成功',
    remark192: '注：上传的文件像素大小请尽量符合207*40！',
    remark193: "故障告警人最多填写2位！",
    remark194: "未设置",
    remark195: '未查询到sim卡信息',
    remark196: '当前终端设备摄像头未开启',
    remark197: '请添加具体配置',
    remark198: '当前部门特殊权限选择',
    remark199: '请选择同步方式',
    remark200: '请选择电梯监控的过期时间',
    remark201: '填写配置平台信息',
    remark202: '绑定的WCR终端ID格式不正确',
    remark203: '注：当前模板用于批量导入功能，注册的电梯信息均为以下配置过的通用信息',
    remark204: "请选择电梯到期时间",
    remark205: "请选择要续费的电梯",
    remark206: "无法注册2G版WCR终端，如需注册请访问IECS官网",
    remark207: "跳转到IECS官网",
    remark208: "用户名只能由数字和字母组成",
    remark209: '是否选择',
    remark210: '未配置电梯的可见电梯厂',
    remark211: '您还没有配置部件预警，请前往',
    remark212: '中进行配置',
    remark213: '部件使用时间归0',
    remark214: '是否已经告警',
    remark215: '归0后此部件的使用时间将重新从0开始计算，请确保真正更换完此部件后执行此操作。',
    remark216: '请选择要绑定的电梯',
    remark217: '请选择将电梯分配至左侧具体公司！',
    remark218: '确定将所选电梯绑定到当前选择公司吗？',
    remark219: '请选择需要分配的公司或用户',
    remark220: '当前电梯已存在选择的公司当中，禁止再次分配',
    remark221: '请选择要取消绑定的电梯',
    remark222: '确认将这些电梯从所选公司中取消绑定吗？',
    remark223: '请选择取消绑定电梯的公司',
    remark224: '请选择需要取消绑定的公司',
    remark225: '确定将这些电梯取消绑定吗？',
    remark226: '当前登录用户无法删除自己账号',
    remark227: '确定恢复当前已删除的设备吗?',
    remark228: '请选择需要绑定的用户(可搜索)',
    remark229: '未选择需要绑定的用户',
    remark230: '当前设备未绑定用户',
    remark231: '未绑定其他用户',
    remark232: '确定导出数据吗？，注意全部导出时间较慢，请您耐心等待。',
    remark233: "请将文件另存为Microsoft Excel 97-2003 格式",
    remark234: "请输入设备名称",
    remark235: "请输入设备描述",
    remark236: "请输入设备型号",
    remark237: "请输入设备品牌",
    remark238: "设备名称不能为空",
    remark239: "点击获取验证码按钮，完成下方验证模块获取验证码",
    remark240: "电梯云提醒您，请绑定您的手机号或邮箱，加强密码复杂度才能继续操作。",
    remark241: "密码长度范围6~30个字符，必须包含数字、大小写字母、特殊字符（!、@、#、$、%、^、&、*、_），不允许出现空格和中文字符。",
    remark242: "请填写正确的m3u8格式地址的视频流",
    remark243: "请选择要删除的记录！",
    remark244: "版本号必须大于0！",
    remark245: "文件大小必须大于0！",
    remark246: "用户的手机号或者邮箱必须填写一个",
    remark247: '平台对接资料，会根据对接功能变化，持续更新。最新版本请以此处为准',
    remark248: '请输入电梯名称、终端号、型号、位置、电梯编号等关键信息',
    remark249: '请选择需要接入或者取消接入的设备',
    remark250: '请选择需要接入方案',
    remark251: '请输入推送平台名称',
    remark252: '是否查询非空值账号',
    remark253: "请选择APK类型",

    // ============================================ remark END ============================================

// ----------------------------操作说明 start ----------------------------
    explain1: '公司类型权限独立，部门类型则拥有父级公司全部权限。',
    explain2: '管理员可见此选项，在创建新的根公司时，可以选择系统默认自带角色，对应右侧所属权限，具体权限分配也可以自定义。',
    explain3: '选中此选项后，当前创建的公司所有电梯只可见通过“绑定电梯”功能的电梯。',
    explain4: '当前角色权限不满足需求，可以勾选此选项添加其他额外权限。',
    explain5: '平台权限指电梯云平台，APP权限指电梯云APP，勾选对应的权限名，为当前角色添加此权限。',
    explain6: '新建的用户是否给与配置电梯过期时间的权限',
    explain7: '为业主分配二维码钥匙时，钥匙在当天的可刷新上限次数，超过此值二维码钥匙当天不能继续获取。',
    explain8: '默认电梯的到期时间为12个月，到期后电梯状态会显示离线，管理员可更改电梯的过期日期',
    explain9: '设置当前用户为当前小区管理员，小区管理员具有可以通过“电梯云乘梯”小程序连接终端设备导出用户数据',
    explain10: '编辑楼层显示信息，具体楼层显示信息根据添加的总楼层数确定，总楼层数 = 正楼层 + 负楼层',
    explain11: '电梯品牌',
    explain12: '选中后的公司可见此台电梯',
    explain13: '选中后的公司及其下属分公司可见此台电梯',
    explain14: '批量修改只支持多台电梯同时修改相同信息',
    explain15: '通过电梯唯一工号及WCR终端ID录入终端信息',
    explain16: '注：此字段可以作为部分推送平台推送配置字段。此字段与推送平台配置中的注册码二选一填写即可。',
    explain17: '开启手动门选项后，电梯详情中的扩展数据功能无法获取到运行开关门次数信息',
    explain18: "自2025年6月23日起，故障告警人最多配置两位，此日期之前原有配置则保留不变！",
    explain19: "故障公众号推送发送规则：同一设备相同故障同一天只发送一次，同一设备每天故障提醒公众号推送最多发送3次。困人故障不做发送次数限制",
    // explain20:"故障提醒公众号推送可退订，退订后将无法继续收到故障提醒公众号推送",  2025年12月10日 放弃用推送公众号推送
    explain21: "公众号推送功能默认开启国内，如果禁用则不使用阿里云公众号推送服务接口，和公众号推送上限配合使用可设置单梯公众号推送提醒发送上限量。",
    explain22: "公众号推送上限为单梯公众号推送提醒次数上限，和公众号推送功能配合使用，如果公众号推送功能开启并且设置上限值，公众号推送提醒达到此值后将不再发送任何提醒公众号推送。",
    explain23: "针对同号码的发送频率公众号推送服务商会进行限制，每分钟内发送上限【50】条，每小时发送上限【50】条，每个自然日发送上限【50】条。",
    explain24: "针对特殊故障码：2（电梯运行时刮门锁）、37（开闸运行过程中运行接触器抖动） 同电梯每天发生三次之后发送一次，然后不再发送。31号故障永不发送公众号推送。26号故障一天发送一次。",
    explain25: '注：自2026年1月19日启，注册国内账号请填写手机号，国外账号请填写邮箱',

// ----------------------------操作说明 end ----------------------------


// ----------------------------hint说明 start ----------------------------

    hint1: '账号不能为空',
    hint2: '手机号不能为空',
    hint3: '验证码不能为空',
    hint4: '公众号推送发送成功，请注意查收',
    hint5: '暂无公司，请创建公司',
    hint6: '推送公众号推送签名申请',
    hint7: '推送公众号推送签名申请，如：【沈阳蓝光】',
    hint8: '手动绑定电梯',
    hint9: '启用特殊权限',
    hint10: '特有权限',
    hint11: '无操作权限',
    hint12: '您没有权限执行此操作',
    hint13: '按回车（Enter）键添加邮箱',
    hint14: '请输入email',
    hint15: '重复的email地址',
    hint16: '是否要删除用户',
    hint17: '是否开启页面故障提示',
    hint18: '请输入楼序号',
    hint19: '该序号已添加',
    hint20: '结束序号不可低于起始序号',
    hint21: '请添加自定义楼序号',
    hint22: '请填写名称',
    hint23: '如：A，墅，高…',
    hint24: '如：#，#楼，号，号楼，栋…',
    hint25: '按回车键（Enter）添加',
    hint26: '如：U，Unit，A…',
    hint27: '如：单元，门…',
    hint28: '人脸乘梯权限开启',
    hint29: '人脸乘梯权限禁用',
    hint30: '扫码乘梯权限开启',
    hint31: '扫码乘梯权限禁用',
    hint32: '选择到期时间',
    hint33: '未修改',
    hint34: '确定删除',
    hint35: '正在视频中，确定关闭吗？',
    hint36: '发起求救事件,请尽快处理',
    hint37: '点击前往监控画面',
    hint38: '已复制到剪贴板',
    hint39: '是否确定删除？',
    hint40: '功能暂未实现',
    hint41: "虚拟电梯不可关注",
    hint42: '请确定当前电梯主从电梯类型',
    hint43: '贯通门楼层总数不得大于32',
    hint44: '从电梯楼层总数不得大于主电梯楼层总数',
    hint45: '年数据统计情况',
    hint46: '数据加载中...',
    hint47: '加载组件中...',
    hint48: '选择您要进行的操作',
    hint49: '不可添加同名',
    hint50: '名称未修改',
    hint51: '名称已存在',
    hint52: '开通充值功能',
    hint53: '刷新负责人列表',
    hint54: '填写公众号推送签名，点击“确认”后即自动提交申请。',
    hint55: '审核通过后，本电梯厂的电梯故障公众号推送推送将携带改签名。',
    hint56: '已认证公众号推送签名',
    hint57: '公众号推送签名未通过审核',
    hint58: '点击重新编辑',
    hint59: '公众号推送签名正在审核中',
    hint60: '填写公众号推送签名，点击“确认”后即自动提交申请。',
    hint61: '审核通过后，本电梯厂的电梯故障公众号推送推送将携带改签名。',
    hint62: '所属公司 / 部门',
    hint63: '请选择当前操作的小区',
    hint64: '求救视频监控',
    hint65: '公众号推送提醒开关',

// ----------------------------hint说明 end ----------------------------

    //微信服务号
    product_manual: '产品说明书',
    machine_manual: '一体机说明书',
    document_search: '输入文档名称搜索',
    access_count: '访问次数',
    document_size: '文档大小',
    document_number: '文档数量',
    view_document: '查看文档',
    preview: '预览',
    previous_page: '上一页',
    next_page: '下一页',
    fault_query: '故障查询',
    err_code: '故障码',
    err_child: '故障子码',
    err_solution: '解决方式',
    err_meaning: '故障含义',
    bind_mobile: '绑定手机号',
    change_mobile: '更换手机号',
    account_binding: '账号绑定',
    old_mobile: '原手机号',
    new_mobile: '新手机号',
    same_mobile: '原手机号与新手机号一致',
    bind_success: '绑定成功',
    bind_tip: '您绑定的账号不存在，请重新绑定',
    dty_gzh:'微信公众号',

}